import { withLazyLoading, WithLazyLoadingProps } from './with-lazy-loading'
import React from 'react'

interface Props {
    available: () => void
    /** True when collection is still loading */
    loading: boolean
    children: (ref: React.RefObject<any>) => React.ReactNode
}

export class InternalImpressionAvailableHelper extends React.Component<
    Props & WithLazyLoadingProps
> {
    static displayName = 'InternalImpressionAvailableHelper'

    componentDidMount() {
        if (!this.props.loading && this.props.lazyLoadHasTriggered) {
            this.props.available()
        }
    }

    componentDidUpdate(prevProps: Props & WithLazyLoadingProps) {
        // There are two conditions which will cause the available callback to the called
        // 1) The data for the collection is already loaded, and the component scrolls into view
        // 2) The component has been scrolled into view already, and the data finishes loading
        const dataIsLoaded = !this.props.loading
        const dataPreviousLoaded = !prevProps.loading

        if (
            !dataPreviousLoaded &&
            dataIsLoaded &&
            !prevProps.lazyLoadHasTriggered &&
            this.props.lazyLoadHasTriggered
        ) {
            this.props.available()
        }

        // Available has triggered through lazy load trigger
        if (dataIsLoaded && !prevProps.lazyLoadHasTriggered && this.props.lazyLoadHasTriggered) {
            this.props.available()
        }

        // Available has triggered through finished loading trigger
        if (this.props.lazyLoadHasTriggered && !dataPreviousLoaded && dataIsLoaded) {
            this.props.available()
        }
    }

    render() {
        return this.props.children(this.props.innerRef)
    }
}

export const ImpressionAvailable = withLazyLoading<Props>(
    InternalImpressionAvailableHelper,
    props => props.percentVisible >= 50
)
ImpressionAvailable.displayName = 'ImpressionAvailable'
